import { createCrudHooks } from './use-crud-factory'
import type { SupabaseQueryChain } from '@/types/supabase-helpers'
import type { Stylist } from '@/types/database.types'

/* ============================================================
   useStylists — PRD §8.4
   CRUD for stylist records, ordered by display_order.
   ============================================================ */

const {
  useList: useStylistList,
  useOne: useStylist,
  useCreate: useCreateStylist,
  useUpdate: useUpdateStylist,
  useDelete: useDeleteStylist,
} = createCrudHooks<Stylist>({
  table: 'stylists',
  queryKey: 'stylists',
  orderBy: 'display_order',
  orderAsc: true,
  defaultFilter: (q: SupabaseQueryChain) => q.eq('is_active', true),
})

/** Admin-only: all stylists including hidden (is_active = false) */
const {
  useList: useAllStylistList,
} = createCrudHooks<Stylist>({
  table: 'stylists',
  queryKey: 'stylists-all',
  orderBy: 'display_order',
  orderAsc: true,
})

export {
  useStylistList,
  useStylist,
  useCreateStylist,
  useUpdateStylist,
  useDeleteStylist,
  useAllStylistList as useAllStylists,
}

/** Convenience: active stylists for tenant-facing views */
export { useStylistList as useStylists }

